import { AxiosInstance } from 'axios'
import {
    ListMasterDataParams,
    MasterDataItem,
    MasterDataItemCreate,
    MasterDataItemUpdate,
    PaginatedMasterDataResponse,
} from './master-data.type'

export class MasterDataApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Get all master data items with pagination
     */
    async list(params?: ListMasterDataParams): Promise<PaginatedMasterDataResponse> {
        const response = await this.client.get<PaginatedMasterDataResponse>('/master-data', {
            params,
        })
        return response.data
    }

    /**
     * Get master data by type ID
     */
    async getByType(
        masterTypeId: string,
        params?: Omit<ListMasterDataParams, 'masterTypeId'>,
    ): Promise<PaginatedMasterDataResponse> {
        return this.list({ ...params, masterTypeId })
    }

    /**
     * Get a single master data item by ID
     */
    async findOne(id: string): Promise<MasterDataItem> {
        const response = await this.client.get<MasterDataItem>(`/master-data/${id}`)
        return response.data
    }

    /**
     * Create a new master data item
     */
    async create(payload: MasterDataItemCreate): Promise<MasterDataItem> {
        const response = await this.client.post<MasterDataItem>('/master-data', payload)
        return response.data
    }

    /**
     * Update a master data item
     */
    async update(id: string, payload: MasterDataItemUpdate): Promise<MasterDataItem> {
        const response = await this.client.put<MasterDataItem>(`/master-data/${id}`, payload)
        return response.data
    }

    /**
     * Toggle active status of a master data item
     */
    async toggleActive(id: string): Promise<MasterDataItem> {
        const response = await this.client.patch<MasterDataItem>(`/master-data/${id}/toggle-active`)
        return response.data
    }

    /**
     * Delete a master data item (soft delete)
     */
    async delete(id: string): Promise<void> {
        await this.client.delete(`/master-data/${id}`)
    }

    /**
     * Bulk delete master data items
     */
    async bulkDelete(ids: string[]): Promise<void> {
        await this.client.delete('/master-data', { data: { ids } })
    }
}
